import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { Row, Col, Label, Table } from "reactstrap";
import {
  TextAreaHookForm,
  SearchableSelectHookForm,
} from "../../../layout/HookFormInputs";
import {
  getTypeOfCheckGroupID,
  getCategoryListDataForAssesment,
  AddNewQuestion,
  getAssesmentQuestionDetailById,
  saveNewQuestion,
} from "../Action";
import { userDetails } from "../../../../helper";
import { useDispatch } from "react-redux";
import Toaster from "../../../common/Toaster";
import LoaderCustom from "../../../common/LoaderCustom";
import { useHistory } from "react-router-dom";

const AddQuestion = ({ addQuestionTab, setActiveTab,addQuestionTabGuid }) => {
  const history = useHistory();
  const formController = useForm({ defaultValues: { IsActive: true } });
  const {
    control,
    register,
    handleSubmit,
    setValue,
    trigger,
    clearErrors,
    setError,
    formState: { errors },
  } = formController;
  const [checkGroupData, setCheckGroupData] = useState([]);
  const [categoryMasterData, setCategoryMasterData] = useState([]);
  const [loading, setLoading] = useState(false); // Loading state
  const [assesmentData, setAssesmentData] = useState(null);
  const dispatch = useDispatch();
  // const urlParams = new URLSearchParams(window.location.search);
  // const addQuestionTab = urlParams.get("questionId");
  useEffect(() => {
    setLoading(true); // Start loading
    getAllCheckGroup();
    getAllCategoryMasterData();
    if (addQuestionTabGuid) {
      getAssesmentQuestionDetailById(addQuestionTabGuid)
        .then(async (res) => {
          const assesmentQuestionData = res?.Data;
          const data = { ...assesmentQuestionData[0] };
          setAssesmentData(data);
          setValue("assessmentQuestion", data?.AssessmentQuestion);
          // {label: , value: ""}
          let catLabels = data?.CategoryNames.split(",");
          let catCodes = data?.CategoryCode.split(",").map((el, index) => {
            return { label: catLabels[index], value: parseInt(el) }
          })

          setValue("categoryCode", catCodes);
          setValue("checkPointGroupID", {
            value: data?.checkPointGroupID || "",
            label: data?.CheckPointGroupName,
          });
          for (let i = 0; i < 5; i++) {
            const optionLabel = data[`Option_${i}_Label`];
            setValue(`remarks_${i}`, optionLabel); // Assuming "remarks" is the name of your text area field
          }
          for (let i = 0; i < 5; i++) {
            const optionLabel = data[`Option_${i}_Label`];
            setValue(`remarks_${i}`, optionLabel);
          }
          // Update table data here
          const updatedTableData = [
            { meaning: data?.Option_0_Label || "" },
            { meaning: data?.Option_1_Label || "" },
            { meaning: data?.Option_2_Label || "" },
            { meaning: data?.Option_3_Label || "" },
            { meaning: data?.Option_4_Label || "" },
          ];
          setTableData(updatedTableData);
          setLoading(false); // Stop loading
        })
        .catch((error) => {
          setLoading(false); // Stop loading
        });
    } else {
      setLoading(false); // Stop loading
    }
  }, [addQuestionTabGuid]);

  const [tableData, setTableData] = useState([
    { meaning: "" },
    { meaning: "" },
    { meaning: "" },
    { meaning: "" },
    { meaning: "" },
  ]);
  const handleMeaningChange = (index, value) => {
    const newData = [...tableData];
    newData[index].meaning = value;
    setTableData(newData);
  };
  const renderTableRows = () => {
    return tableData.map((row, index) => (
      <tr key={index}>
        <th scope="row">{index + 1}</th>
        <td>
          <TextAreaHookForm
            className="hl-textarea-q"
            label={false}
            name={`remarks_${index}`}
            Controller={Controller}
            control={control}
            register={register}
            mandatory={true}
            handleChange={(e) => {
              const value = e.target.value;
              handleMeaningChange(index, value);
              
              if (!validateSpecialChars(value)) {
                setError(`remarks_${index}`, {
                  type: "pattern",
                  message: "Input cannot start or end with special characters"
                });
              } else {
                clearErrors(`remarks_${index}`);
              }
            }}
            defaultValue={row.meaning}
            customClassName={"withBorder"}
            errors={errors[`remarks_${index}`]}
            disabled={false}
            rules={{
              required: {
                value: true,
                message: "This field is required"
              }
            }}
          />
        </td>
      </tr>
    ));
  };
  const constructPayload = () => {
    const payload = {};
    tableData.forEach((row, index) => {
      payload[`option_${index}_Label`] = row.meaning;
    });
    return payload;
  };
  const onSubmit = async (data) => {
    setLoading(true); // Set loading to true during submission
    let otherSpecializationString = Array.isArray(data?.categoryCode)
      ? data.categoryCode.map((item) => item.value).join(",")
      : null;
    const userDetail = userDetails();
    const { assessmentQuestion, checkPointGroupID } = data;
    const payload = {
      assessmentQuestion,
      checkPointGroupID:
        checkPointGroupID?.value || assesmentData?.CheckPointGroupID,
      categoryCode: otherSpecializationString || assesmentData?.CategoryCode,
      employeeId: userDetail?.EmployeeId,
      ...constructPayload(),
    };

    if (addQuestionTab) {
      const payloadUpload = {
        ...payload,
        assessmentQuestionId: addQuestionTab,
      };
      dispatch(
        saveNewQuestion(payloadUpload, (res) => {
          setLoading(false); // Set loading to false regardless of success or failure
          if (res && res?.IsSuccessful) {
            Toaster.success(res?.Data?.Message);
            history.push("/assessment-master");
          } else {
            Toaster.error(res?.data?.ErrorMessage || "Form submission failed");
          }
        })
      );
    } else {
      dispatch(
        AddNewQuestion(payload, (res) => {
          setLoading(false); // Set loading to false regardless of success or failure
          if (res && res?.IsSuccessful) {
            Toaster.success(res?.Data?.Message);
            history.push("/assessment-master");
          } else {
            Toaster.error(res?.Data?.Message || "Form submission failed");
          }
        })
      );
    }
  };

  const getAllCheckGroup = () => {
    setLoading(true); // Set loading to true during data fetching
    getTypeOfCheckGroupID()
      .then((res) => {
        setCheckGroupData(res?.Data);
      })
      .catch(() => { })
      .finally(() => setLoading(false)); // Set loading to false after data fetching
  };
  const getAllCategoryMasterData = () => {
    setLoading(true); // Set loading to true during data fetching
    getCategoryListDataForAssesment()
      .then((res) => {
        setCategoryMasterData(res?.Data);
      })
      .catch(() => { })
      .finally(() => setLoading(false)); // Set loading to false after data fetching
  };
  const renderListing = (label) => {
    if (label === "checkPointGroupListing") {
      return checkGroupData.map((checkPointGroupListingID) => ({
        value: checkPointGroupListingID.Id,
        label: checkPointGroupListingID.Name,
      }));
    }
    if (label === "categoryMasterData") {
      return categoryMasterData.map((categoryMasterData) => ({
        value: categoryMasterData.Id,
        label: categoryMasterData.SupplierCategory,
      }));
    }
  };
  const validateSpecialChars = (value) => {
    if (!value) return true;
    
    // Check if the first character is alphanumeric
    const firstChar = /^[a-zA-Z0-9]/;
    // Check if the last character is alphanumeric
    const lastChar = /[a-zA-Z0-9]$/;
    
    // Only show error if either first or last character is not alphanumeric
    if (!firstChar.test(value[0]) || !lastChar.test(value[value.length - 1])) {
      return false;
    }
    return true;
  };
  if (loading) {
    return (
      <div>
        {" "}
        <LoaderCustom customClass="simulation-Loader" />
      </div>
    ); // Render loading indicator if loading is true
  }
  return (
    <form onSubmit={handleSubmit(onSubmit)} className="h-100">
      <div className="bg-white hl-common-page hl-questions-page h-100 d-flex flex-column">
        <Row className={`filter-row-large`}>
          <Col md="12" className="mb-2">
            <h1>{addQuestionTab ? "Update New Question" : "Add New Question"}</h1>
          </Col>
        </Row>
        <div className="h-100">
          <Row className="part-detail-wrapper mt-2">
            <Col md="7" className="hl-enter-que">
              <TextAreaHookForm
                label="Enter Question"
                name="assessmentQuestion"
                Controller={Controller}
                control={control}
                register={register}
                mandatory={true}
                handleChange={(e) => {
                  const value = e.target.value;
                  if (!validateSpecialChars(value)) {
                    setError("assessmentQuestion", {
                      type: "pattern",
                      message: "Input cannot start or end with special characters"
                    });
                  } else {
                    clearErrors("assessmentQuestion");
                  }
                }}
                defaultValue={""}
                className=""
                customClassName={"withBorder"}
                errors={errors.assessmentQuestion}
                disabled={false}
                rules={{
                  required: {
                    value: true,
                    message: "This field is required"
                  }
                }}
              />
            </Col>
            <Col md="5">
              <Row>
                <Col md="12">
                  <SearchableSelectHookForm
                    {...register("checkPointGroupID")}
                    label={"Select Checkpoint Group"}
                    name={"checkPointGroupID"}
                    placeholder={"Select"}
                    Controller={Controller}
                    control={control}
                    rules={{ required: true }}
                    options={renderListing("checkPointGroupListing")}
                    mandatory={true}
                    handleChange={() => { }}
                    errors={errors.checkPointGroupID}
                    disabled={false}
                  />
                </Col>
                <Col md="12" className="hl-select-cat-master">
                  <SearchableSelectHookForm
                    {...register("categoryCode")}
                    label={"Select Categories"}
                    name={"categoryCode"}
                    placeholder={"Select"}
                    Controller={Controller}
                    control={control}
                    isMulti={true}
                    rules={{ required: true }}
                    options={renderListing("categoryMasterData")}
                    mandatory={true}
                    handleChange={() => { }}
                    errors={errors.categoryCode}
                    disabled={false}
                  />
                </Col>
              </Row>
            </Col>
            <Col md="12">
              <Label>
                <strong>Options</strong><span className="asterisk-required">*</span>
              </Label>
              <Table bordered>
                <thead>
                  <tr className="sd-common-heading">
                    <th style={{ width: "80px" }}>S. No.</th>
                    <th>Meaning</th>
                  </tr>
                </thead>
                <tbody>{renderTableRows()}</tbody>
              </Table>
            </Col>
          </Row>
        </div>
        <div className="justify-content-between sf-btn-footer no-gutters hl-btm-footer justify-content-between sticky-btn-footer">
          <div className="col-sm-12 text-right bluefooter-butn">
            <button
              type={"button"}
              className="reset mr-2 cancel-btn"
              onClick={() => setActiveTab("main")}
            >
              <div className={"cancel-icon"}></div>
              {"Cancel"}
            </button>
            <button type="submit" className="submit-button save-btn">
              <div class="save-icon"></div>
              {addQuestionTab ? "Update" : "Save"}
            </button>
          </div>
        </div>
      </div>
    </form>
  );
};
export default AddQuestion;